import { springAdminRequest } from "./springAdminApi";

export type ChatbotRequest = {
  id: number;
  created_at: string;
  category: string;
  brand: string;
  product_name: string;
  purchase_location: string;
  purchase_date: string;
  purchase_price: string;
  repair_history: string;
  user_name: string;
  user_phone: string;
  appraisal_num: string;
  appraisal_status_id: number;
  is_pay: boolean;
  feedback: string;
  images: string[];
};

export type ChatbotListParams = {
  status_id?: string;
  q?: string;
  page?: number;
  page_size?: number;
  start_date?: string;
  end_date?: string;
};

type ListResponse<T> = {
  message: string;
  data: T[];
  pagination?: {
    total_items: number;
    current_page: number;
    page_size: number;
  };
};

type ItemResponse<T> = { message: string; data: T };
type TrackingLinkResponse = { message: string; data: { tracking_url: string } };
type SmsCreditResponse = { message: string; data: { point: number } };
export type ChatbotSmsLog = { id: number; status: "accepted"; text: string; createdAt: string };

export const chatbotAdminApi = {
  list: (params: ChatbotListParams = {}) =>
    springAdminRequest.get<ListResponse<ChatbotRequest>>("web-appraisal-requests", { params }),

  get: (id: number | string) =>
    springAdminRequest.get<ItemResponse<ChatbotRequest>>(`web-appraisal-requests/${id}`),

  update: (id: number | string, values: Partial<Pick<ChatbotRequest, "appraisal_status_id" | "is_pay" | "feedback">>) =>
    springAdminRequest.patch<ItemResponse<ChatbotRequest>>(`web-appraisal-requests/${id}`, values),

  issueAdditionalImageLink: (id: number | string) =>
    springAdminRequest.post<TrackingLinkResponse>(`web-appraisal-requests/${id}/additional-image-link`),

  listTemplates: () =>
    springAdminRequest.get<ListResponse<{ id: number; text: string; type: string }>>(
      "web-appraisal-requests/message-templates",
    ),

  sendMessage: (id: number | string, values: { msg_template_id?: number; text: string }) =>
    springAdminRequest.post<ItemResponse<ChatbotSmsLog>>(
      `web-appraisal-requests/${id}/messages`,
      values,
    ),

  listSentMessages: (id: number | string) =>
    springAdminRequest.get<ItemResponse<ChatbotSmsLog[]>>(`web-appraisal-requests/${id}/messages`),

  getSmsCredit: () =>
    springAdminRequest.get<SmsCreditResponse>("web-appraisal-requests/sms-credit"),
};
